/**
 * Live Preview Component
 *
 * Displays a live preview of the shipping bar with current settings.
 * Single Responsibility: Render live preview
 */
import { Title, Text, Box } from '@mantine/core';

export const LivePreview = ({ settings }) => {
  const isModernStyle = settings.layout_style === 'modern';

  // Generate preview message by replacing {amount} placeholder with example amount
  const previewMessage = settings.message_initial.replace('{amount}', '$25.00');

  return (
    <div>
      <style>{`@keyframes revoty-preview-stripes { from { background-position: 0 0; } to { background-position: 20px 0; } }`}</style>
      <Title order={4} mb="sm">Live Preview</Title>
      <Box
        style={{
          backgroundColor: settings.bg_color,
          padding: '16px',
          borderRadius: '8px',
          position: 'relative',
          overflow: 'hidden',
        }}
      >
        <Text
          size="sm"
          style={{
            color: settings.text_color,
            marginBottom: '8px',
            fontWeight: 500,
          }}
        >
          {previewMessage}
        </Text>
        <Box
          style={{
            height: '8px',
            backgroundColor: 'rgba(255, 255, 255, 0.2)',
            borderRadius: '4px',
            overflow: 'hidden',
            position: 'relative',
          }}
        >
          <Box
            style={{
              height: '100%',
              width: '60%',
              backgroundColor: settings.bar_color,
              borderRadius: '4px',
              transition: 'width 0.3s ease',
              ...(isModernStyle && {
                backgroundImage: 'linear-gradient(45deg, rgba(255, 255, 255, 0.15) 25%, transparent 25%, transparent 50%, rgba(255, 255, 255, 0.15) 50%, rgba(255, 255, 255, 0.15) 75%, transparent 75%, transparent)',
                backgroundSize: '20px 20px',
                animation: 'revoty-preview-stripes 1s linear infinite',
              }),
            }}
          />
        </Box>
      </Box>
    </div>
  );
};
